import { render, staticRenderFns } from "./billList.vue?vue&type=template&id=53d24998&scoped=true"
import script from "./billList.vue?vue&type=script&lang=js"
export * from "./billList.vue?vue&type=script&lang=js"
import style0 from "./billList.vue?vue&type=style&index=0&id=53d24998&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d24998",
  null
  
)

export default component.exports